import React, { Component } from 'react'
import { Card } from 'react-bootstrap';

import '../Styles.css';

class RetencionGeneralInfo extends Component {
  render() {
    const { data = {} } = this.props;

    return (
      <Card>
        <Card.Body>
          <strong className="text-info card-label-info">Retención: </strong>
          { data.cveretenc } { !!data.descretenc ? ` ${data.descretenc}` : '' }
          <br/>

          <strong className="text-info card-label-info">Folio Fiscal: </strong>
          { data.uuid }
          <br/>

          <strong className="text-info card-label-info">Emisor: </strong>
          { data.emisor_rfc } { data.emisor_razon_social || '' }
          <br/>

          <strong className="text-info card-label-info">Receptor: </strong>
          { data.receptor_rfc } { data.receptor_razon_social || '' }
          <br/>

          { !!data.folio && (
              <span>
                <strong className="text-info card-label-info">Folio: </strong>
                { data.folio }
                <br/>
              </span>
            )
          }

          <strong className="text-info card-label-info">Ejercicio: </strong>
          { data.mesini.padStart(2, '0') + '-' + data.mesfin.padStart(2, '0') + ' ' + data.ejercicio }
          <br/>

          <strong className="text-info card-label-info">Operación: </strong>
          { data.monto_operacion }
          <br/>

          <strong className="text-info card-label-info">Retenido: </strong>
          { data.monto_retenido }
          <br/>
        </Card.Body>
      </Card>
    )
  }
}

export default RetencionGeneralInfo;